export default class Map {
    constructor() {
        this.selector = 'map';
        this.init();
    }

    init() {
        var self = this;

        if ( $( '#' + self.selector ).length < 1 ) {
            return;
        }

        if ( typeof google === 'object' && typeof google.maps === 'object' ) {

            var mapStyles = [ {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#fefefe"
                }, {
                    "lightness": "20"
                }, {
                    "gamma": "1.00"
                } ]
            }, {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [ {
                    "color": "#fefefe"
                }, {
                    "lightness": "17"
                }, {
                    "gamma": "1"
                }, {
                    "weight": "1.2"
                } ]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "administrative",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "administrative.country",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "gamma": "1.74"
                } ]
            }, {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#f5f5f5"
                }, {
                    "lightness": "20"
                }, {
                    "gamma": "1.00"
                } ]
            }, {
                "featureType": "landscape",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#f5f5f5"
                }, {
                    "lightness": "21"
                }, {
                    "gamma": "1.00"
                } ]
            }, {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "poi.attraction",
                "elementType": "labels.text.stroke",
                "stylers": [ {
                    "hue": "#ff0000"
                } ]
            }, {
                "featureType": "poi.business",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "lightness": "21"
                }, {
                    "gamma": "1.00"
                }, {
                    "hue": "#ff0000"
                } ]
            }, {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "poi.school",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "hue": "#ff0000"
                } ]
            }, {
                "featureType": "poi.school",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#ffffff"
                }, {
                    "lightness": "29"
                }, {
                    "gamma": "1.00"
                }, {
                    "weight": "0.2"
                } ]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [ {
                    "hue": "#ff0000"
                } ]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#ffffff"
                }, {
                    "lightness": "18"
                }, {
                    "gamma": "1.00"
                } ]
            }, {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#ffffff"
                }, {
                    "lightness": "16"
                }, {
                    "gamma": "1.00"
                } ]
            }, {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "road.local",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#f2f2f2"
                } ]
            }, {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [ {
                    "visibility": "off"
                } ]
            }, {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [ {
                    "color": "#e9e9e9"
                }, {
                    "lightness": "17"
                } ]
            }, {
                "featureType": "water",
                "elementType": "geometry.stroke",
                "stylers": [ {
                    "color": "#ff0000"
                } ]
            }, {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            }, {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [ {
                    "color": "#b3a17b"
                } ]
            } ];

            var mapOptions = {
                zoom: parseInt( themeMapVars.zoom ),
                center: new google.maps.LatLng( themeMapVars.location.lat, themeMapVars.location.lng ),
                draggableCursor: '',
                draggable: false,
                scrollwheel: false,
                panControl: false,
                mapTypeId: 'roadmap',
                mapTypeControl: false,
                scaleControl: false,
                zoomControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                styles: mapStyles,
                backgroundColor: 'none'
            };

            var map,
                markers = [],
                markerIcon = new google.maps.MarkerImage( themeMapVars.marker, null, null, null, new google.maps.Size( 38, 32 ) ),
                markerPoiIcon = new google.maps.MarkerImage( themeMapVars.marker_poi, null, null, null, new google.maps.Size( 24, 21 ) ),
                bounds = new google.maps.LatLngBounds();

            map = new google.maps.Map( document.getElementById( self.selector ), mapOptions );

            markers[0] = new google.maps.Marker( {
                position: new google.maps.LatLng( themeMapVars.location.lat, themeMapVars.location.lng ),
                icon: markerIcon,
                map: map,
                zIndex: 99
            } );

            if ( typeof themeMapVars.poi !== 'undefined' ) {
                for ( var i = 0; i < themeMapVars.poi.length; i++ ) {
                    var currentNumber = i + 1;

                    markers[ currentNumber ] = new google.maps.Marker( {
                        position: new google.maps.LatLng( themeMapVars.poi[ i ].lat, themeMapVars.poi[ i ].lng ),
                        icon: markerPoiIcon,
                        map: map,
                        label: {
                            color: '#ffffff',
                            fontWeight: '700',
                            fontSize: '11px',
                            text: currentNumber.toString()
                        },
                    } );

                    bounds.extend( markers[ currentNumber ].position );
                }

                $( '[data-map-center]' ).on( 'click', function(e) {
                    var markerNumber = parseInt( $( this ).attr( 'data-map-center' ) ),
                    selectedMarker = markers[ markerNumber ];

                    map.panTo( selectedMarker.position );
                } );
            }
        }
    }
}